import React, { useState, useRef, useEffect, useContext } from "react";
import "../../../../stylesheet/forms.css";
import { RiCloseLine } from "react-icons/ri";
import { addAppointment } from "../../../../Utils/localStore";
import ResponsibleDept from "../../utils/ResponsibleDept";
import ToastContext from "../../../../context/toasterContex";
import ContextApi from "../../../../context/ContextApi";

const NewAppointment = ({
  details,
  cancel,
  update,
  type,
  classes,
  onContinue,
  onBack,
}) => {
  const [appointmentData, setAppointmentData] = useState({
    userLocalId: details?.localID ?? null,
    user: details,
    status: "Pending",
  });
  const { setAppointment, appointment } = useContext(ContextApi);
  const { toast } = useContext(ToastContext);
  const appointmentForm = useRef(null);
  const [respDept, setRespDept] = useState([]);

  const handleFormUpdate = (e) => {
    const { id, value } = e.target;

    let today = Date.now();
    const formatter = new Intl.DateTimeFormat([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    today = formatter.format(today);

    setAppointmentData({
      ...appointmentData,
      departments: respDept,
      date: today,
      [id]: value,
    });
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    await addAppointment(appointmentData)
      .then((resp) => {
        update();
        toast.success("Appointment Added successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        toast.error("Something went wrong, please try again later", {
          position: toast.POSITION.TOP_CENTER,
        });
        throw new Error(err);
      });
    cancel(e);
  };
  const sendToBack = () => {
    onBack();
  };
  const updateFormData = () => {
    setAppointment((prevData) => ({
      ...prevData,
      ...appointmentData,
    }));
  };
  useEffect(() => {
    if (appointment) {
      setAppointmentData(appointment);
      console.log(appointment?.departments);
      setRespDept(appointment?.departments);
    }
    if (appointmentForm.current) {
      appointmentForm.current.scrollIntoView(true);
      const r = document.querySelector("#appt_form1");
      r.scrollIntoView();
    }
  }, []);
  return (
    <section
      ref={appointmentForm}
      id="appt_form2"
      className={`font-euclid-circular-a w-full ` + classes}
    >
      {type !== "fresh" && (
        <div className="w-full bg-primary rounded-t-md sticky top-0">
          <div className="flex justify-between w-full align-middle">
            <h2 className="text-white text-xl font-semibold leading-7 tracking-wide p-8">
              Schedule Appointment
            </h2>
            <div className="leading-7 text-xl font-semibold  p-8">
              <button onClick={cancel}>
                {" "}
                <RiCloseLine color="white" size={30} />{" "}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="p-8 h-[700px] overflow-hidden overflow-y-auto">
        <form
          id="appt_form1"
          className="appt_form"
          onSubmit={(e) => handleFormSubmit(e)}
        >
          <label htmlFor="title">Title of Appointment</label>
          <input
            className="titleInput"
            type="text"
            id="title"
            name="title"
            defaultValue={appointmentData?.title}
            onChange={(e) => handleFormUpdate(e)}
            placeholder="Enter appointment title"
          />
          <label htmlFor="description">Task Description</label>
          <textarea
            id="description"
            className="h-[118px]"
            defaultValue={appointmentData?.description}
            placeholder="Enter a description..."
            onChange={(e) => handleFormUpdate(e)}
          />
          <label htmlFor="department">Responsible Department</label>
          {/* <input
            type="text"
            id="department"
            name="department"
            placeholder="Enter responsible department"
            onChange={(e) => handleFormUpdate(e)}
          /> */}

          <ResponsibleDept
            preSelected={respDept}
            selected={respDept}
            ifAllergy={(data) =>
              setRespDept(data.filter((item) => item.status))
            }
          />

          <label htmlFor="personnel">Assigned personnel</label>
          <input
            type="text"
            id="personnel"
            name="personnel"
            onChange={(e) => handleFormUpdate(e)}
            defaultValue={appointmentData?.personnel}
            placeholder="Enter assigned personnel"
          />
          <label htmlFor="date">Execution Date</label>
          <div className="custom_date">
            <input
              className="date_input"
              type="date"
              defaultValue={appointmentData?.ex_date || ""}
              onChange={(e) => handleFormUpdate(e)}
              id="ex_date"
              name="ex_date"
              placeholder="DD/MM/YYYY"
            />
          </div>

          <div className="flex justify-between gap-2 my-2 w-full">
            <div className="w-full md:w-1/2">
              <label htmlFor="start_time">Start Time</label>
              <input
                id="start_time"
                className="w-full"
                type="time"
                defaultValue={appointmentData?.start_time}
                onChange={(e) => handleFormUpdate(e)}
              />
            </div>

            <div className="w-full md:w-1/2">
              <label htmlFor="end_time">End Time</label>
              <input
                className="w-full"
                id="end_time"
                type="time"
                defaultValue={appointmentData?.end_time}
                onChange={(e) => handleFormUpdate(e)}
              />
            </div>
          </div>

          <label htmlFor="appt_type">Appointment type</label>
          <select
            name="appt_type"
            id="appt_type"
            value={appointmentData?.appt_type}
            onChange={(e) => handleFormUpdate(e)}
          >
            <option disabled selected>
              Select appointment type
            </option>
            <option value="in-person">In person</option>
            <option value="virtuals">Virtual</option>
          </select>
          {type !== "fresh" ? (
            <div className="flex justify-between gap-2 py-2">
              <button
                type="submit"
                className="rounded-md text-white bg-primary p-2 w-full"
              >
                Submit
              </button>
              <button
                autoFocus
                className="p-2 border border-red-400 rounded-md w-full"
                onClick={(e) => {
                  e.preventDefault();
                  cancel(e);
                }}
              >
                Cancel
              </button>
            </div>
          ) : (
            <>
              <div className="flex justify-between gap-2 py-2 ">
                <button
                  type="button"
                  className="p-2 border border-primary rounded-md w-1/3"
                  onClick={sendToBack}
                >
                  Back
                </button>
                {/* disabled={} */}
                <button
                  type="button"
                  onClick={async () => {
                    await updateFormData();
                    onContinue();
                  }}
                  className="rounded-md text-white bg-primary p-2 w-2/3"
                >
                  Proceed
                </button>
                {/* disabled */}
              </div>
            </>
          )}
        </form>
      </div>
    </section>
  );
};

export default NewAppointment;
